// import { SignUpForm } from "./components/SignUpForm";
// import { WelcomeSection } from "./components/WelcomeSection";

// export function Onboarding() {
//   return (
//     <div className="flex overflow-hidden relative w-screen h-screen bg-white max-md:flex-col max-md:h-auto">
//       <WelcomeSection />
//       <SignUpForm />

//     </div>
//   );
// }

// export default Onboarding;

import { useParams } from "react-router-dom";
import { SignUpForm } from "./components/SignUpForm";
import { WelcomeSection } from "./components/WelcomeSection";
import LoginForm from "./components/LoginForm";
import CompanySetup from "./components/CompanySetup";
import { removeUser } from "../../utils/userSlice";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

export function Onboarding() {
  const { o_stage } = useParams();
  const path = window.location.pathname;
  const dispatch = useDispatch();

  const renderStageComponent = () => {
    console.log("path name", path);

    if (path === "/") return <LoginForm />;

    switch (o_stage) {
      case "signup":
        return <SignUpForm />;
      case "login":
        return <LoginForm />;
      case "companySetup":
        return <CompanySetup />;
      default:
        return <div className="text-center text-red-500">Invalid stage</div>;
    }
  };

  return (
    <div className="flex overflow-hidden relative w-screen h-screen bg-white max-md:flex-col max-md:h-auto">
      <WelcomeSection />
      {renderStageComponent()}
    </div>
  );
}

export default Onboarding;
